import type { EngineLayer } from '@mighty-map/map-engine';
import type { LayerConfig, Manifest } from '../../api/types';
import { MAX_ZOOM } from '../engineLayers';

/**
 * Layers Data Passport added to the map from another theme (production added any theme's layer to the map in
 * front of you). They draw on top of the theme's own layers, last added on top, in their own style; a layer the
 * active theme already holds is left to the theme.
 */
export interface AddedLayer {
  layerId: string;
  title: string;
  /** The App view groups it was added under (the "Added to the map" list groups by them). */
  groupPath: string[];
}

export function mergeAdded(
  themeLayers: readonly EngineLayer[],
  added: readonly AddedLayer[],
  layers: ReadonlyMap<string, LayerConfig>,
  manifest: Manifest | null,
): EngineLayer[] {
  if (!added.length) return themeLayers as EngineLayer[];
  const present = new Set(themeLayers.map((l) => l.id));
  const tiles = new Map((manifest?.layers ?? []).map((m) => [m.layer_id, m.tiles_url]));
  const extra: EngineLayer[] = [];
  for (const a of added) {
    const cfg = layers.get(a.layerId);
    const url = tiles.get(a.layerId);
    if (!cfg || !url || present.has(a.layerId)) continue;
    present.add(a.layerId);
    extra.push({
      id: a.layerId,
      sourceUrl: url,
      sourceLayer: a.layerId,
      styleLayers: cfg.style,
      visible: true,
      minzoom: cfg.zoom.min,
      maxzoom: cfg.zoom.max ?? MAX_ZOOM,
    });
  }
  return extra.length ? [...themeLayers, ...extra] : (themeLayers as EngineLayer[]);
}
